// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

import App from './App'
import router from './router'

Vue.use(Vuetify, { theme: {
  primary: '#1A0DAB',
  secondary: '#000',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data () {
    return {
      pageHeader: {
        section: null,
        title: null
      },
      // NOTE: Sidenav routes are the names of the routes from routes/index.js
      // TODO: Should have used route meta for the titles, suffixes, and whatnot... oops
      // Would have reduced duplication
      sidenav: [{
        title: 'Welcome',
        classSuffix: 'intro',
        route: 'welcome-congrats'
      }, {
        title: 'Academics',
        classSuffix: 'academics',
        items: [{
          title: 'Overview',
          route: 'academics-overview'
        }, {
          title: 'Undergraduate Business Administration',
          route: 'academics-undergrad-ba'
        }, {
          title: 'World Bachelor in Business',
          route: 'academics-wbb'
        }, {
          title: 'Undergraduate Accounting',
          route: 'academics-undergrad-accounting'
        }, {
          title: 'Business Cinematic Arts',
          route: 'academics-business-cinematic-arts'
        }, {
          title: 'Real Estate Finance + Development',
          route: 'academics-realestate'
        }, {
          title: 'Artificial Intelligence for Business',
          route: 'academics-aib'
        }, {
          title: 'Double Majors and Minors',
          route: 'academics-double-majors'
        }, {
          title: 'Electives',
          route: 'academics-electives'
        }]
      }, {
        title: 'Advantages',
        classSuffix: 'opportunities',
        items: [{
          title: 'Experiential Learning',
          route: 'opportunities-experiential-learning'
        }, {
          title: 'Global Opportunities',
          route: 'opportunities-global-opportunities'
        }, {
          title: 'Interships and Career Services',
          route: 'opportunities-internships'
        }, {
          title: 'Scholar Distinction',
          route: 'advantages-thematic'
        }, {
          title: 'Faculty',
          route: 'academics-faculty'
        }, {
          title: 'Visiting Speakers',
          route: 'opportunities-visiting-speakers'
        }, {
          title: 'L.A. Advantages',
          route: 'opportunities-why-la'
        }]
      }, {
        title: 'Campus Life',
        classSuffix: 'life',
        items: [{
          title: 'Student Organizations',
          route: 'opportunities-student-organizations'
        }, {
          title: 'Community Engagement',
          route: 'opportunities-community-involvement'
        }, {
          title: 'Recreational Sports',
          route: 'opportunities-recreational-sports'
        }, {
          title: 'Enjoying Los Angeles',
          route: 'opportunities-enjoying-la'
        }, {
          title: 'Facilities',
          route: 'life-facilities'
        }, {
          title: 'USC Housing',
          route: 'life-residence-halls'
        }, {
          title: 'Transportation',
          route: 'life-transportation'
        }]
      }, {
        title: 'Next Steps',
        route: 'next-steps',
        classSuffix: 'next_steps'
      }, {
        title: 'Resources',
        classSuffix: 'resources',
        items: [{
          title: 'Marshall Undergraduate Programs',
          route: 'resources-marshall-undergraduate-programs'
        }, {
          title: 'USC Admissions, Financial Aid, and Student Accounts',
          route: 'resources-usc-admissions-financial-aid-student-accounts'
        }, {
          title: 'Housing and Transportation',
          route: 'resources-housing-transportation'
        }, {
          title: 'International Students',
          route: 'resources-international-students'
        }, {
          title: 'Orientation and Tours',
          route: 'resources-oreintation-tours'
        }, {
          title: 'Academic Resources',
          route: 'resources-academic-resources'
        }, {
          title: 'Libraries',
          route: 'resources-libraries'
        }, {
          title: 'Administrative Services',
          route: 'resources-administrative-services'
        }, {
          title: 'Wellness and Safety',
          route: 'resources-wellness-safety'
        }, {
          title: 'Student Organizations and Affinity Groups',
          route: 'resources-student-organizations'
        }, {
          title: 'Athletics and Recreation',
          route: 'resources-athletics-recreations'
        }]
      }]
    }
  },
  methods: {
    setPageHeader (section, title) {
      this.pageHeader.section = section
      this.pageHeader.title = title
    }
  },
  watch: {
    '$route' (to, from) {
      // Wipe the page header properties and let the pages re-populate them
      this.$root.pageHeader.section = null
      this.$root.pageHeader.title = null
    }
  },
  created () {
    /* Hack to put the section class suffix on the route information
    so it can colorize the section nav */
    this.sidenav.forEach(n => {
      if (n.items) {
        n.items.forEach(i => {
          i.classSuffix = n.classSuffix
        })
      }
    })
  },
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js